import * as React from "react";
const SvgIcStarVariantFilled = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 .833 7.5 7.5.833 10 7.5 12.5l2.5 6.667 2.5-6.667 6.667-2.5L12.5 7.5 10 .833Z" /></svg>;
export default SvgIcStarVariantFilled;